
import React from "react";
export default function OperatingSystem() {
    return(
        <section className="pt-60 pb-60">
            <div className="pb-60">
                <div className="container">
                    <div className="row g-4 justify-content-center">
                        <div className="col-md-10 col-xl-7">
                            <div className="text-center sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                <h2 className="mb-4">
                                    Award-winning web hosting
                                </h2>
                                <p className="mb-0 max-text-52 mx-auto">
                                    Whether you run an e-commerce site or a web business you want to attract as many visitors as
                                    possible to your website.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="row g-4">
                    <div className="col-md-6 col-xl-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <div className="card rounded-3 h-100">
                            <div className="card-header pt-6 border-bottom-0">
                                <div className="d-block text-center">
                                    <img src="images/alma-linux.png" alt="image" className="img-fluid" />
                                </div>
                            </div>
                            <div className="card-body pb-6">
                                <h6 className="mb-2 fs-18 text-center">
                                    <span className="d-block text-decoration-none text-dark hover:text-primary">
                                        Alma Linux
                                    </span>
                                </h6>
                                <div className="hstack gap-1 justify-content-center align-items-center mb-4">
                                    <span className="d-block">
                                        Versions:
                                    </span>
                                    <span className="d-block fw-bold text-dark hover:text-primary fs-14 text-decoration-none">
                                        8.x | 9.x
                                    </span>
                                </div>
                                <p className="mb-0 tt-line-clamp tt-clamp-3 text-center">
                                    AlmaLinux delivers stability, licensing freedom, performance, control, and peace of mind.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-xl-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                        <div className="card rounded-3 h-100">
                            <div className="card-header pt-6 border-bottom-0">
                                <div className="d-block text-center">
                                    <img src="images/debian1.png" alt="image" className="img-fluid" />
                                </div>
                            </div>
                            <div className="card-body pb-6">
                                <h6 className="mb-2 fs-18 text-center">
                                    <span className="d-block text-decoration-none text-dark hover:text-primary">
                                        Debian
                                    </span>
                                </h6>
                                <div className="hstack gap-1 justify-content-center align-items-center mb-4">
                                    <span className="d-block">
                                        Versions:
                                    </span>
                                    <span className="d-block fw-bold text-dark hover:text-primary fs-14 text-decoration-none">
                                        10.x | 11.x | 12.x
                                    </span>
                                </div>
                                <p className="mb-0 tt-line-clamp tt-clamp-3 text-center">
                                    Debian offers full control, clarity, scalability, security, productivity, and stability for everyone.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-xl-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                        <div className="card rounded-3 h-100">
                            <div className="card-header pt-6 border-bottom-0">
                                <div className="d-block text-center">
                                    <img src="images/ubuntu1.png" alt="image" className="img-fluid" />
                                </div>
                            </div>
                            <div className="card-body pb-6">
                                <h6 className="mb-2 fs-18 text-center">
                                    <span className="d-block text-decoration-none text-dark hover:text-primary">
                                        Ubuntu
                                    </span>
                                </h6>
                                <div className="hstack gap-1 justify-content-center align-items-center mb-4">
                                    <span className="d-block">
                                        Versions:
                                    </span>
                                    <span className="d-block fw-bold text-dark hover:text-primary fs-14 text-decoration-none">
                                        20.x | 22.x | 24.x
                                    </span>
                                </div>
                                <p className="mb-0 tt-line-clamp tt-clamp-3 text-center">
                                    Ubuntu is intuitive, scalable, and compatible-perfect for beginners needing a flexible system.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-xl-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="600" data-sal-easing="ease-in-out-sine">
                        <div className="card rounded-3 h-100">
                            <div className="card-header pt-6 border-bottom-0">
                                <div className="d-block text-center">
                                    <img src="images/windows.png" alt="image" className="img-fluid" />
                                </div>
                            </div>
                            <div className="card-body pb-6">
                                <h6 className="mb-2 fs-18 text-center">
                                    <span className="d-block text-decoration-none text-dark hover:text-primary">
                                        Windows
                                    </span>
                                </h6>
                                <div className="hstack gap-1 justify-content-center align-items-center mb-4">
                                    <span className="d-block">
                                        Versions: 
                                    </span>
                                    <span className="d-block fw-bold text-dark hover:text-primary fs-14 text-decoration-none">
                                        2016 | 2019 | 2022
                                    </span>
                                </div>
                                <p className="mb-0 tt-line-clamp tt-clamp-3 text-center">
                                    Windows servers deliver classic corporate familiarity with enterprise performance, stability, and power.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}